import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TODOS = "__todos__";
const NENHUM = "__nenhum__";

export interface OpcaoCadastroRh {
  id: number;
  rotulo: string;
  detalhe?: string;
  ativo: boolean;
}

export interface SelectCadastroRhProps {
  /** undefined = "todos" (filtro); 0 = "nenhum". */
  value: number | undefined;
  onChange: (v: number | undefined) => void;
  /** Rótulo da opção "todos" (só em filtros). Sem ele, a opção não aparece. */
  rotuloTodos?: string;
  /** Rótulo da opção 0 (ex.: "Sem jornada", "Usar a do cadastro"). `null` esconde a opção. */
  rotuloNenhum?: string | null;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Base dos selects de cadastros do RH (jornada, departamento, cargo): Radix Select com
 * sentinelas (nunca `value=""`), inativos só aparecem se já estiverem selecionados.
 */
export function SelectCadastroRh({
  value, onChange, rotuloTodos, rotuloNenhum, placeholder, disabled, className, opcoes,
}: SelectCadastroRhProps & { opcoes: OpcaoCadastroRh[] }) {
  const atual = value === undefined ? (rotuloTodos ? TODOS : undefined) : value === 0 ? NENHUM : String(value);
  const visiveis = opcoes.filter((o) => o.ativo || o.id === value);
  const selecionadoSumiu = !!value && value > 0 && opcoes.length > 0 && !opcoes.some((o) => o.id === value);

  return (
    <Select
      value={atual ?? ""}
      disabled={disabled}
      onValueChange={(v) => onChange(v === TODOS ? undefined : v === NENHUM ? 0 : Number(v))}
    >
      <SelectTrigger className={className}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {rotuloTodos && <SelectItem value={TODOS}>{rotuloTodos}</SelectItem>}
        {rotuloNenhum !== null && <SelectItem value={NENHUM}>{rotuloNenhum ?? "Nenhum"}</SelectItem>}
        {visiveis.map((o) => (
          <SelectItem key={o.id} value={String(o.id)}>
            {o.rotulo}
            {o.detalhe && <span className="ml-2 text-xs text-muted-foreground">{o.detalhe}</span>}
            {!o.ativo && <span className="ml-2 text-xs text-muted-foreground">(inativo)</span>}
          </SelectItem>
        ))}
        {selecionadoSumiu && <SelectItem value={String(value)}>(cadastro excluído)</SelectItem>}
      </SelectContent>
    </Select>
  );
}
